//@flow
import ChatStore from './chatStoreClass';

export default new ChatStore();
